import { v4 } from '../../../common/components/UUID';
import { setItemInPersistentStore, getItemFromPersistentStore } from './Persist';

const getDeviceId = () => {
  if (getItemFromPersistentStore('deviceId', '')) return getItemFromPersistentStore('deviceId');
  const newDeviceId = v4();
  setItemInPersistentStore('deviceId', newDeviceId);
  return newDeviceId;
}

export default getDeviceId;
